import { City } from "@/providers/ReadyProvider";
import _ from "lodash";

/**
 * 将所有城市数据转成级联选择器接收的数据格式
 * @param citiesData 接口拿到的所有城市数据
 * @returns 
 */
export const getCity = (citiesData) => {
    return citiesData?.map((city) => {
        const { name, code, child_city } = city;
        return {
            value: code,
            label: name,
            ...(child_city && child_city.length && { children: getCity(child_city) }),
        };
    }) ?? []
};

/**
 * 按城市的code拼好城市名(101001001 => 上海市 - 上海市 - 浦东新区)
 * @param cityCode 城市的code字符串值
 * @param allCities 所有城市数据
 * @returns 格式：上海市 - 上海市 - 浦东新区
 */
export const getConcatCity = (cityCode: string, allCities: City[]): string => {
    return getConcatCityUtil('', cityCode, allCities);
};

/**
 * getConcatCity的主要执行工具方法
 * @param concatString 拼好的城市名的字符串 起始为空字符串
 * @param cityCode 城市的code字符串值
 * @param allCities 所有城市数据
 * @returns 返回拼好的城市名
 */
const getConcatCityUtil = (concatString: string, cityCode: string, allCities: City[]): string => {
    let concatValue = concatString;
    const city = allCities?.find((city) => cityCode?.startsWith(city.value)) ?? null;
    if (city) {
        concatValue = `${concatValue}${concatValue ? ' - ' : ''}${city.label}`;
        if (city.children) {
            return getConcatCityUtil(concatValue, cityCode, city.children);
        } else {
            return concatValue;
        }
    } else {
        return concatValue;
    }
};

/**
 * 根据拼好的城市名获取城市code(上海市 - 上海市 - 浦东新区 => 101001001)
 * @param concatCity 拼好的城市名 格式：上海市 - 上海市 - 浦东新区
 * @param allCities 所有城市数据
 * @returns 
 */
export const getCityCode = (concatCity: string, allCities: City[]): string => {
    const cityArr = concatCity?.split(' - ') ?? [];
    return getCityCodeUtil(0, cityArr, allCities, '');
};

/**
 * getCityCode的主要执行工具方法
 * @param i 递归内for循环的index 初始为0 每进入下一层就加1
 * @param cityArr 拼好的城市按“ - ”字符串分割后的各级城市名数组
 * @param allCities 所有城市数据
 * @param code 城市code 默认是空字符串
 * @returns 返回城市code 没找到城市就返回code参数
 */
const getCityCodeUtil = (i = 0, cityArr: string[], allCities: City[], code = ''): string => {
    const len = cityArr.length;
    for (i; i < len; i++) {
        const city = allCities?.find(city => city.label === cityArr[i]) ?? null;
        const code = city?.value ?? '';
        if (city) {
            if (city.children) {
                return getCityCodeUtil(i + 1, cityArr, city.children, code);
            } else {
                return code;
            }
        }
    }
    return code;
}

/**
 * 获取带￥前缀的金额
 * @param value 金额字符串
 * @param defaultValue 空值时显示
 * @param precision 保留小数点位数
 * @returns 
 */
export const getPrice = (value, defaultValue: string | number = '', precision?: number) => {
    if (_.isNil(value)) return defaultValue;
    const price = _.isNil(precision) ? parseFloat(value) : parseFloat(Number(value).toFixed(precision));
    return !(_.isNil(price) || _.isNaN(price)) ? `￥${price}` : defaultValue;
};